import { observer } from 'mobx-react'
import React, { FC, PropsWithChildren } from 'react'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'

type TypedAccordionProps = {
  summary: string | React.ReactElement
  onEdit?: () => void
  defaultOpenState?: boolean
  isWhite?: boolean
  disabled?: boolean
  customOpen?: boolean
  contentPadding?: string | number
  arrowIcon?: any
  setCustomOpen?: (
    newValue: boolean,
  ) => void | React.Dispatch<React.SetStateAction<boolean>>
  disableEditIcon?: boolean
  leftIcon?: boolean
  backgroundColor?: string
  headColor?: string
}
const TypedAccordion: FC<PropsWithChildren<TypedAccordionProps>> = ({
  onEdit,
  summary,
  defaultOpenState = true,
  children,
  disabled = false,
  customOpen,
  setCustomOpen,
  contentPadding,
  arrowIcon,
  disableEditIcon = false,
  leftIcon = false,
  backgroundColor,
  headColor,
}) => {
  return (
    // @ts-ignore
    <CustomAccordion
      summary={summary}
      defaultOpenState={defaultOpenState}
      arrowIcon={arrowIcon}
      checkboxAction={null}
      checked={null}
      checkedServiceOrderId={null}
      contentPadding={contentPadding}
      headColor={headColor}
      height={null}
      index={null}
      onEdit={onEdit}
      leftIcon={leftIcon}
      openedAccordionIndex={null}
      orderId={null}
      setChecked={null}
      setOpenedAccordionIndex={null}
      reverseIcon={false}
      disabled={disabled}
      customOpen={customOpen}
      setCustomOpen={setCustomOpen}
      disableEditIcon={disableEditIcon}
      backgroundColor={backgroundColor}
    >
      {children}
    </CustomAccordion>
  )
}

export default observer(TypedAccordion)
